
/**
 * Register all common Vue componenents here.
 */
Vue.component('login-form', require('./components/forms/Login.vue'));
Vue.component('nav-menu', require('./components/NavMenu.vue'));
Vue.component('taskbar', require('./components/Taskbar.vue'));
Vue.component('schedule', require('./components/Schedule.vue'));
Vue.component('schedule-entry', require('./components/ScheduleEntry.vue'));
Vue.component('table-skeleton', require('./components/TableSkeleton.vue'));
Vue.component('calendar', require('./components/Calendar.vue'));
Vue.component('calendar-collapse', require('./components/CalendarCollapse.vue'));
Vue.component('calendar-dropdown', require('./components/CalendarDropdown.vue'));

Vue.component('model-autocomplete', require('./components/ModelAutocomplete.vue'));

Vue.component('attachments', require('./components/Attachments.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/components.js